const overrideRegimeMessage = 'Changing reporting regime will result in setting field enrichment to default values (i.e. Do Not populate) and matching key will be set to default values for that Regime and end point filtering logic, expected overreports and underreports will be removed. Are you sure you want to proceed?';

export { overrideRegimeMessage };
